module.exports = __webpack_public_path__ + "static/media/payByPhone.0548ceca.svg";